import React, { useRef } from 'react'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { Modal } from '../../common/Modal'
import { ModalBody } from '../../common/Modal/ModalBody'
import { ModalHeader } from '../../common/Modal/ModalHeader'
import { FindArchiveChatsModalContent } from '../FindArchivedChatsModalContent'
import { ConversationType } from '../../../generated/api/chat-conversations'

interface FindArchiveChatsModalProps {
  show: boolean
  close: () => void
  onItemSelect: () => void
  type: ConversationType
}

export const FindArchiveChatsModal = ({
  show,
  close,
  onItemSelect,
  type,
}: FindArchiveChatsModalProps): JSX.Element => {
  const { translate } = useAppTranslation()
  const ref = useRef(null)
  return (
    <Modal ref={ref} show={show}>
      {{
        header: (
          <ModalHeader onClose={close}>
            {translate('findArchivedChats.header')}
          </ModalHeader>
        ),
        body: (
          <ModalBody className="max-h-96 overflow-y-auto">
            <FindArchiveChatsModalContent
              modalRef={ref}
              close={onItemSelect}
              type={type}
            />
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
